import { useContext, useEffect, useRef, useState } from "react";
import classes from "./RouteMaster.module.css";
import Modal from "../../../../Shared/PopupModal/PopupModal";
import {
  MastersChangeLog,
  findChangedValues,
  getCompanyMaster,
  getCompanyMasterPagination,
  saveMastersApi,
} from "../../../Utility";
import RouteUploadExcel from "./RouteUploadExcel";
import { toast } from "react-toastify";
//import AutoComplete from "../../FreightMaster/UploadExcel/AutoComplete/AutoComplete";
import AutoComplete from "../../../../Shared/AutosuggestV2/Autosuggestv2";
import Select from "react-select/creatable";
import { Urls } from "../../../../../Urls";
import Axios from "../../../../../Axios";
import Loader from "../../../../Loader";
import { UserApiContext } from "../../../../UserDetailsContext/UserDetailsContext";
import _ from "lodash";
import { useMixPanelForTracking } from "../../../../../utils/TrackMixPanel";
import axios from "../../../../../Axios/Axios";
import Pagination from "react-js-pagination";
import MasterDropdown from "../MasterDropdown";
import DownloadMastersButton from "../../Utility/DownloadMastersButton";
import { MyCompanyProfileContext } from "../../../../../MyCompanyProfileContext";
import { isSuperUser } from "../../FreightMaster/UploadExcel/Step1/utils";
import { sendMailToMasters } from "../../Utility/utility";
import { EditableEmailsContext } from "../../../../../Context/EditableEmailsContext";
import MultiSelectFilterUI from "../../../../Shared/newfilterui/MultiSelectFilterUI";
import ShowHistory from "../../../../Planning/components/ShowHistory";

/**
 * RouteMaster Component
 * handles logic and displays route master.
 *
 * @returns {JSX.Element}
 */
const RouteMaster = ({
  canedit = true,
  canAccess,
  canUpdate,
  checkActionPermission,
}) => {
  const [routeMasterList, setRouteMasterList] = useState([]);
  const [company_id, setcompany_id] = useState("");
  const { companyProfile, userDetails } = useContext(UserApiContext);
  const [show, setshow] = useState(false);
  const [added_list, setAdded_list] = useState([]);
  const [remark, setRemark] = useState("");
  const [deletion_list, setDeletion_list] = useState([]);
  // const [superAdmin , setSuperAdmin] = useState(false)
  const [skipactive, setSkipactive] = useState(0);
  const [totalcount, settotalcount] = useState(0);
  const [downloadData, setDownloadData] = useState([]);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [selectedOrg, setSelectedOrg] = useState("company");
  const [orgList, setOrgList] = useState([]);
  const [isOrgLevel, setIsOrgLevel] = useState(false);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );

  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [filtersshown, setfiltershown] = useState(false);

  const DEFAULT_SORT_OPTIONS = [
    { value: "route_code", label: "Route Code" },
    { value: "route_type", label: "Route Type" },
    { value: "distance", label: "Distance" },
    { value: "duration", label: "Duration" },
  ];

  const lastFetchedCompanyId = useRef(null);
  const isOrgMounted = useRef(false);

  const [superAdmins, setSuperAdmins] = useState([]);
  const [emailTemplate, setEmailTemplate] = useState({
    from: "",
    content: "",
    subject: "",
    cc: [],
    description: "",
  });

  const emailData = useContext(EditableEmailsContext);

  useEffect(() => {
    if (emailData && emailData?.notifyEmailForMastersUpdate) {
      setEmailTemplate({
        content: emailData?.notifyEmailForMastersUpdate?.content,
        subject: emailData?.notifyEmailForMastersUpdate?.subject,
        cc:
          emailData?.notifyEmailForMastersUpdate?.cc ||
          "connect@logisticsnow.in",
        from: emailData?.notifyEmailForMastersUpdate?.from,
        description: emailData?.notifyEmailForMastersUpdate?.email_description,
      });
    }
  }, [emailData]);

  useEffect(() => {
    if (
      companySettingData &&
      companySettingData?.contact_information &&
      companySettingData?.contact_information?.length > 0
    ) {
      const superAdminEmails = companySettingData?.contact_information
        ?.filter((t) => t?.super_admin === true)
        ?.map((m) => {
          return {
            name: m?.name,
            email: m?.email,
          };
        });
      if (superAdminEmails && superAdminEmails?.length > 0) {
        setSuperAdmins(superAdminEmails);
      } else {
        setSuperAdmins([]);
      }
    } else {
      setSuperAdmins([]);
    }
  }, [companySettingData]);

  const buildDefaultPayload = (skip = 0, limit = 500) => ({
    filter_opertaion: "and",
    date_range: [],
    filters: [],
    sort: { key: "route_code", order: "asc" },
    pagination: { skip, limit },
  });

  const getRouteData = (payload, orgId, showToast = false) => {
    setshow(true);
    const org = orgId || selectedOrg;
    const orgParam = org && org !== "company" ? `&organization_id=${org}` : "";
    const url = `${Urls.companyMaster}?master_type=route&action=fetch_masters_data${orgParam}`;
    axios
      .post(url, payload)
      .then((res) => {
        let masterDetails = [];
        let total = 0;

        if (res.data) {
          if (res.data.master_details) {
            masterDetails = res.data.master_details;
            total =
              res.data.total !== undefined
                ? res.data.total
                : res.data.total_count !== undefined
                  ? res.data.total_count
                  : res.data.master_details.length;
          } else if (Array.isArray(res.data)) {
            if (res.data.length > 0 && res.data[0].master_details) {
              masterDetails = res.data[0].master_details;
              total =
                res.data[0].total !== undefined
                  ? res.data[0].total
                  : res.data[0].total_count !== undefined
                    ? res.data[0].total_count
                    : res.data[0].master_details.length;
            } else {
              masterDetails = res.data;
              total = res.data.length;
            }
          }
        }

        setRouteMasterList(masterDetails);
        settotalcount(total);
        setAdded_list([]);

        if (showToast) {
          toast.success(`Found ${total} results`);
        }
        setshow(false);
      })
      .catch((err) => {
        console.log(err);
        if (showToast) {
          toast.error("Failed to apply filters");
        }
        setshow(false);
      });
  };

  // useeffect for fetching first 500 routes and company/user details
  useEffect(() => {
    const id = companyProfile?.domain_data?.company_id;
    if (!id || !userDetails) return;
    if (id === lastFetchedCompanyId.current) return;

    lastFetchedCompanyId.current = id;
    setcompany_id(id);

    getRouteData(buildDefaultPayload(0, 500), selectedOrg);
  }, [companyProfile, userDetails]);

  useEffect(() => {
    if (!isOrgMounted.current) {
      isOrgMounted.current = true;
      return;
    }
    if (!lastFetchedCompanyId.current) return;
    getRouteData(buildDefaultPayload(0, 500), selectedOrg);
  }, [selectedOrg]);

  useEffect(() => {
    if (companySettingData && companySettingData.contact_information) {
      const result = isSuperUser(companySettingData.contact_information, userDetails.email);
      if (result) {
        if (result.organizationList && result.organizationList.length > 0) {
          setOrgList(result.organizationList);
        }
      }
    }
    if (companySettingData && companySettingData.masters_setting) {
      if (
        companySettingData.masters_setting.masters_show_level &&
        companySettingData.masters_setting.masters_show_level ===
        "organization_level"
      ) {
        setIsOrgLevel(true);
      }
    }
  }, [companySettingData]);

  /**
   * Handles deletion of a route master item.
   * @param {Event} e - Event object
   * @param {Object} item - Route master item to be deleted
   */
  const deleteHandler = (e, item) => {
    const deletedItem = {
      company_id: item.company_id,
      domain: item.domain,
      email: item.email,
      route_id: item.route_id,
      origin: item.origin,
      destination: item.destination,
      route_type: item.route_type,
      distance: item.distance ? item.distance : "",
      duration: item.duration ? item.duration : "",
      spot_route: item.spot_route ? item.spot_route : false,
      route_code: item.route_code,
      no_of_hops: item.no_of_hops ? item.no_of_hops : "",
      sort_order: item.sort_order ? item.sort_order : "",
      route_status: "deleted",
      last_updated_timestamp: new Date(),
    };
    if (window.confirm("Are you sure you want to delete?")) {
      setshow(true);
      let finalUrl = "";
      if (
        selectedOrg === "company" ||
        !selectedOrg ||
        selectedOrg === undefined
      ) {
        finalUrl = `${Urls.companyMaster}?edit=route&company_id=${company_id}`;
      } else {
        finalUrl = `${Urls.companyMaster}?edit=route&company_id=${company_id}&organization_id=${selectedOrg}`;
      }
      Axios.put(finalUrl, deletedItem)
        .then((res) => {
          toast.success("Deleted successfully");
          setshow(false);
          sendMailToMasters(
            "Route Master",
            emailTemplate,
            superAdmins,
            {
              action: "Route Deleted",
              lane: item,
            },
            setshow,
            userDetails?.user_name || userDetails?.email?.split("@")[0],
          );
          var activity = [
            {
              route_id: item.route_id,
              route_code: item.route_code,
              route_name: `${item.origin.location_name} to ${item.destination.location_name}`,
            },
          ];
          MastersChangeLog(
            "Line Item Deleted",
            "route_master",
            userDetails.email,
            userDetails.user_id,
            company_id,
            activity,
            remark,
          );
        })
        .catch((e) => {
          console.log(e);
          setshow(false);
        });

      var temp = routeMasterList;
      var list = [];
      if (temp && temp.length > 0) {
        temp.map((data) => {
          if (data !== item) {
            list.push(data);
          }
        });
      }
      setRouteMasterList(list);
    }
  };

  /**
   * AddNewItem Component
   * Component for adding a new route master item.
   *
   * @param {Array<Object>} routeMasterList - Current list of route master items
   * @returns {JSX.Element}
   */
  const AddNewItem = ({ routeMasterList, setRouteMasterList }) => {
    const [origin, setorigin] = useState({});
    const [inputorigin, setinputorigin] = useState("");
    const [destination, setdestination] = useState({});
    const [route_type, setRoute_type] = useState("");
    const [inputdestination, setinputdestination] = useState("");
    const [distance, setDistance] = useState();
    const [duration, setDuration] = useState();
    const [route_code, setRoute_code] = useState("");
    const [spot_route, setSpotRoute] = useState();
    const [hops, setHops] = useState("");
    const [sort, setSort] = useState("");

    /**
     * Adds a new route master item.
     * @param {Event} e - Event object for add click event
     */
    const addRouteMaster = (e) => {
      const user_mail = userDetails.email;
      const editRouteMaster = {
        company_id: company_id,
        origin: origin,
        destination: destination,
        route_type: route_type,
        distance: distance,
        duration: duration,
        spot_route: spot_route,
        route_code: route_code,
        no_of_hops: hops,
        sort_order: sort,
        domain: companyProfile.allowed_domains[0],
        email: user_mail,
        route_status: "active",
        last_updated_timestamp: new Date(),
      };
      const route_master = [editRouteMaster];

      // Handle potential SQL Injection
      const sqlInjectionPatterns =
        /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

      if (sqlInjectionPatterns.test(origin)) {
        toast.error("Please add valid origin");
      } else if (sqlInjectionPatterns.test(destination)) {
        toast.error("Please add valid destination");
      } else if (sqlInjectionPatterns.test(route_code)) {
        toast.error("Please add valid route code");
      } else if (sqlInjectionPatterns.test(sort)) {
        toast.error("Please add valid sort order");
      } else if (validateAllFields(editRouteMaster)) {
        setshow(true);
        saveMastersApi(
          company_id,
          "route",
          route_master,
          selectedOrg,
          TrackMixPanel,
          userDetails?.email, userDetails?.user_name
        )
          .then((res) => {
            if (res.data.status === false) {
              if (res.data.message.includes("Route code(s) already exist")) {
                toast.error(res.data.message);
              } else if (res.data.message.includes("already exist in Route Master")) {
                const codes = res.data.error_codes?.join(", ") || "";
                toast.error(
                  `Duplicate route: ${codes}. Use a different origin & destination or update the existing route.`
                );
              } else {
                toast.error(res.data.message || "Failed to add route master");
              }
              setshow(false);
              return;
            } else {
              sendMailToMasters(
                "Route Master",
                emailTemplate,
                superAdmins,
                {
                  action: "New Route Added",
                  lane: editRouteMaster,
                },
                setshow,
                userDetails?.user_name || userDetails?.email?.split("@")[0],
              );
              setshow(false);
              toast.success("Data submitted successfully");
              var activity = {
                route_code: editRouteMaster.route_code,
                route_name: `${editRouteMaster.origin.location_name} to ${editRouteMaster.destination.location_name}`,
              };
              MastersChangeLog(
                "Line Item Added",
                "route_master",
                userDetails.email,
                userDetails.user_id,
                company_id,
                activity,
                "",
              );
              TrackMixPanel({
                ModuleName: "masters",
                ScreenName: "other master - route master",
                Definition:
                  "user has clicked on add details route master button",
                Data: `User Added Origin: ${editRouteMaster?.origin?.location_name ? editRouteMaster.origin.location_name : "none"}, Destination :${editRouteMaster?.destination?.location_name ? editRouteMaster.destination.location_name : "none"}, Route Type :${editRouteMaster?.route_type ? editRouteMaster.route_type : "none"}, Distance :${editRouteMaster?.distance ? editRouteMaster.distance : "none"}, Duration : ${editRouteMaster?.duration ? editRouteMaster.duration : "none"}, Route code: ${editRouteMaster?.route_code ? editRouteMaster.route_code : "none"}, Spot Route: ${editRouteMaster?.spot_route ? editRouteMaster.spot_route : "none"}, No. of hops: ${editRouteMaster?.no_of_hops ? editRouteMaster.no_of_hops : "none"}, sort order: ${editRouteMaster?.sort_order ? editRouteMaster.sort_order : "none"}`,
              });
              setRouteMasterList([...routeMasterList, editRouteMaster]);
              setorigin({});
              setinputorigin("");
              setdestination({});
              setRoute_type("");
              setinputdestination("");
              setDistance("");
              setDuration("");
              setRoute_code("");
              setSpotRoute("");
              setHops("");
              setSort("");
              const closeBtn = document.getElementById("close_addRouteMaster");
              if (closeBtn) closeBtn.click();
            }
          })
          .catch((err) => {
            setshow(false);
            console.log(err);
          });
      }
    };
    /**
     * Function to handle validation of input fields
     * @param {Object} material - route master item to validate
     * @returns {void} does not return anything
     */
    const validateAllFields = (material) => {
      if (
        material.origin.location_name === "" ||
        material.origin.location_name !== inputorigin ||
        material.destination.location_name !== inputdestination ||
        material.destination.location_name === "" ||
        inputorigin.trim() === "" ||
        inputdestination.trim() === "" ||
        material.distance === undefined ||
        material.duration === undefined ||
        material.route_code.trim() === "" ||
        material.route_type.trim() === "" ||
        material.spot_route === undefined ||
        isNaN(material.distance) ||
        isNaN(material.duration) ||
        isNaN(material.spot_route)
      ) {
        toast.error("Please Fill All Fields");
        return false;
      } else if (material.distance <= 0 || material.duration <= 0) {
        toast.error("Field Cannot be 0 or Negative");
        return false;
      } else if (
        material.origin.location_name === material.destination.location_name
      ) {
        toast.error("Origin and Destination Cannot be same");
        return false;
      } else {
        return true;
      }
    };

    /**
     * Handles deletion of lanes
     * @param {Event} e - Event for delete button click
     * @returns {void} does not return anything
     */
    const deleteLanes = (e) => {
      if (deletion_list && deletion_list.length > 0) {
        if (window.confirm("Are you sure to delete?")) {
          setshow(true);
          var payload = {
            data: deletion_list,
          };
          let finalUrl =
            selectedOrg === "company" ||
              !selectedOrg ||
              selectedOrg === undefined
              ? `${Urls.companyMaster}?edit=route&company_id=${companyProfile.domain_data.company_id}&status=deleted`
              : `${Urls.companyMaster}?edit=route&company_id=${companyProfile.domain_data.company_id}&organization_id=${selectedOrg}&status=deleted`;
          axios
            .put(finalUrl, payload)
            .then((res) => {
              sendMailToMasters(
                "Route Master",
                emailTemplate,
                superAdmins,
                {
                  action: `Multiple Item(s) Deleted`,
                  lane: "",
                },
                setshow,
                userDetails?.user_name || userDetails?.email?.split("@")[0],
              );
              TrackMixPanel({
                ModuleName: "masters",
                ScreenName: "other master - route master",
                Definition:
                  "user has clicked on route master bulk delete button",
                Data: JSON.stringify({
                  deleted_count: deletion_list.length,
                  route_codes: deletion_list.map(
                    (deletedLane) => deletedLane.route_code,
                  ),
                }),
              });
              toast.success("Lanes deleted successfully");
              const updatedList = routeMasterList.filter(
                (truck) =>
                  !deletion_list.some((deletedLane) => deletedLane === truck),
              );
              setRouteMasterList(updatedList);
              setshow(false);
              setDeletion_list([]);
            })
            .catch((err) => {
              console.log(err);
              setshow(false);
            });
        }
      } else {
        toast.error("Please Select atleast 1 item");
        return false;
      }
    };

    return (
      <div className="row col-md-12 px-3 pb-3">
        <div
          className="d-flex align-items-center flex-wrap w-100"
          style={{ gap: "10px" }}
        >
          <Modal
            buttonLabel={
              <>
                <i className="fa fa-plus pr-2" />
                Add Route Master
              </>
            }
            buttonClass="btn btn-primary"
            style={{
              fontSize: "12px",
              backgroundColor: "#3f51b5",
              borderColor: "#3f51b5",
            }}
            disabled={canedit || !canUpdate}
            content={
              <div className="p-2">
                <div className="row m-0 mb-3">
                  <div
                    className="col-md-4 px-2"
                    style={{
                      pointerEvents: canedit || !canUpdate ? "none" : "auto",
                    }}
                  >
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Origin <span className="required-field"> *</span>
                    </span>
                    <AutoComplete
                      key="Origin_Key"

                      module_key="indents"
                      user_identifier={userDetails?.profile_company_id}

                      value={
                        inputorigin
                          ? { label: inputorigin, value: inputorigin }
                          : null
                      }

                      placeholder="Origin/Code"

                      onChange={(val) => setinputorigin(val)}     // string
                      onSelect={(obj) => setorigin(obj)}          // full object

                      className="mt-1"

                      isDisabled={canedit || !canUpdate}

                      customStyles={{
                        control: (base, state) => ({
                          ...base,
                          height: "37px",
                          minHeight: "37px",
                          borderRadius: "4px",
                          border: state.isFocused
                            ? "1px solid #80bdff"
                            : "1px solid #ced4da",
                          boxShadow: "none",
                        })
                      }}
                    />
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Origin ID
                    </span>
                    <input
                      value={origin?.location_code || ""}
                      disabled
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                    />
                  </div>
                  <div
                    className="col-md-4 px-2"
                    style={{
                      pointerEvents: canedit || !canUpdate ? "none" : "auto",
                    }}
                  >
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Destination <span className="required-field"> *</span>
                    </span>
                    <AutoComplete
                      key="Destination_Key"

                      module_key="indents"
                      user_identifier={userDetails?.profile_company_id}

                      value={
                        inputdestination
                          ? { label: inputdestination, value: inputdestination }
                          : null
                      }

                      placeholder="Destination/Code"

                      onChange={(val) => setinputdestination(val)}   // string
                      onSelect={(obj) => setdestination(obj)}        // full object

                      className="mt-1"

                      isDisabled={canedit || !canUpdate}

                      customStyles={{
                        control: (base, state) => ({
                          ...base,
                          height: "37px",
                          minHeight: "37px",
                          borderRadius: "4px",
                          border: state.isFocused
                            ? "1px solid #80bdff"
                            : "1px solid #ced4da",
                          boxShadow: "none",
                        })
                      }}
                    />
                  </div>
                </div>
                <div className="row m-0 mb-3">
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Destination ID
                    </span>
                    <input
                      value={destination?.location_code || ""}
                      disabled
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                    />
                  </div>
                  <div
                    className="col-md-4 px-2"
                    style={{
                      pointerEvents: canedit || !canUpdate ? "none" : "auto",
                    }}
                  >
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Route Type <span className="required-field"> *</span>
                    </span>
                    <Select
                      options={[
                        { value: "point_to_point", label: "Point-to-Point" },
                      ]}
                      isMulti={false}
                      onChange={(e) => setRoute_type(e.value)}
                      className="basic-single mt-1"
                      classNamePrefix="select"
                      defaultValue={route_type}
                      isSearchable={false}
                      isDisabled={canedit || !canUpdate}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "37px",
                          height: "37px",
                        }),
                      }}
                    />
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Distance <span className="required-field"> *</span>
                    </span>
                    <input
                      type="number"
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                      onChange={(e) => setDistance(Number(e.target.value))}
                      value={distance}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                </div>
                <div className="row m-0 mb-3">
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Duration <span className="required-field"> *</span>
                    </span>
                    <input
                      type="number"
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                      onChange={(e) => setDuration(Number(e.target.value))}
                      value={duration}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Route Code <span className="required-field"> *</span>
                    </span>
                    <input
                      type="text"
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                      onChange={(e) => setRoute_code(e.target.value)}
                      value={route_code}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div
                    className="col-md-4 px-2"
                    style={{
                      pointerEvents: canedit || !canUpdate ? "none" : "auto",
                    }}
                  >
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Spot Route <span className="required-field"> *</span>
                    </span>
                    <Select
                      options={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" },
                      ]}
                      isMulti={false}
                      onChange={(e) => setSpotRoute(e.value)}
                      className="basic-single mt-1"
                      classNamePrefix="select"
                      defaultValue={spot_route}
                      isSearchable={false}
                      isDisabled={canedit || !canUpdate}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "37px",
                          height: "37px",
                        }),
                      }}
                    />
                  </div>
                </div>
                <div className="row m-0 mb-3">
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      No. of hops
                    </span>
                    <input
                      type="number"
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                      onChange={(e) => setHops(e.target.value)}
                      value={hops}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-4 px-2">
                    <span style={{ fontWeight: "600", fontSize: "13px" }}>
                      Sort Order
                    </span>
                    <input
                      type="text"
                      className="form-control mt-1"
                      style={{ height: "37px" }}
                      onChange={(e) => setSort(e.target.value)}
                      value={sort}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                </div>
                <div className="row m-0 justify-content-center mt-4 mb-2">
                  <button
                    className="btn btn-success px-4"
                    disabled={canedit || !canUpdate}
                    onClick={(e) => addRouteMaster(e)}
                  >
                    Add Route Details
                  </button>
                </div>
              </div>
            }
            title="Add Route Master"
            id="addRouteMasterModal"
            closeButtonId="close_addRouteMaster"
            screenName="Route Master"
            moduleName="Route Master"
            backdrop="static"
            size="xl"
          />

          <Modal
            buttonLabel={
              <>
                <i className="fa fa-upload mr-1" />
                Upload Files
              </>
            }
            buttonClass="btn btn-primary"
            style={{ fontSize: "12px" }}
            disabled={canedit || !canUpdate}
            content={
              <RouteUploadExcel
                selectedOrg={selectedOrg}
                superAdmins={superAdmins}
                emailTemplate={emailTemplate}
                routeMasterList={routeMasterList}
                setRouteMasterList={setRouteMasterList}
                added_list={added_list}
                setAdded_list={setAdded_list}
                company_id={company_id}
              />
            }
            title={`Route Master`}
            id="closebutton"
            screenName="Company Profile"
            moduleName="Route Master"
            activityName="Route Master - Upload excel"
            onClose={() =>
              getRouteData(buildDefaultPayload(0, 500), selectedOrg)
            }
            closeButtonId="close_contactus1"
          />

          <button
            id="submitLane"
            style={{}}
            disabled={deletion_list.length === 0 || canedit || !canUpdate}
            className="btn btn-sm btn-danger"
            onClick={deleteLanes}
          >
            <i className="fa fa-trash mr-2" />
            Delete
          </button>

          <DownloadMastersButton
            type={"route"}
            company_id={company_id}
            masterList={routeMasterList}
            totalCount={totalcount}
          />

          <button
            id="route-filter-btn"
            className={`btn ${isFilterActive ? "btn-success" : "btn-primary"} btn-sm px-3 text-nowrap`}
            onClick={() => setfiltershown(!filtersshown)}
            title={isFilterActive ? "Filters are active" : "Advanced Filters"}
          >
            <i
              className={`fa ${isFilterActive ? "fa-check-circle" : "fa-filter"} mr-2`}
            />
            {isFilterActive ? "Filters Applied" : "Filter"}
          </button>
          <div className="ml-auto">
            <Modal
              id="activity-log-modal"
              buttonLabel={
                <>
                  <i
                    className="far fa-clock pr-2"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <span>Show Activity</span>
                </>
              }
              buttonClass={`btn btn-info btn-sm px-3 text-nowrap`}
              disabled={canedit || !canUpdate}
              content={<ShowHistory screen_name={"route_master"} />}
              screenName="Other Masters"
              moduleName="Masters"
              title="Activity Log"
            />
          </div>
        </div>
      </div>
    );
  };

  /**
   * EditRouteMaster Component
   * Component for editing an existing route master item.
   *
   * @param {Object} routeMaster - Route master item to be edited
   * @param {number} index - Index of the item in the list
   * @param {Object} userDetails - Current user details
   * @returns {JSX.Element}
   */
  const EditRouteMaster = ({
    routeMaster,
    index,
    userDetails,
    superAdmins,
    emailTemplate,
  }) => {
    const [locationName1, setLocationName1] = useState(
      routeMaster.origin.location_name,
    );
    const [locationName2, setLocationName2] = useState(
      routeMaster.destination.location_name,
    );
    const [origin, setOrigin] = useState(routeMaster.origin);
    const [destination, setDestination] = useState(routeMaster.destination);
    const [prevData, setPrevData] = useState({});

    useEffect(() => {
      var temp = _.cloneDeep(routeMaster);
      setPrevData(temp);
    }, [routeMaster]);

    /**
     * Handles saving edited route master item.
     * @param {Object} routeMaster - Edited route master item
     * @param {number} index - Index of the item in the list
     */
    const handleEditSave = (routeMaster, index) => {
      // const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))/i;
      const sqlInjectionPatterns =
        /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

      if (sqlInjectionPatterns.test(routeMaster.origin)) {
        toast.error("Please add valid origin");
      } else if (sqlInjectionPatterns.test(routeMaster.destination)) {
        toast.error("Please add valid destination");
      } else if (sqlInjectionPatterns.test(routeMaster.route_code)) {
        toast.error("Please add valid route code");
      } else if (sqlInjectionPatterns.test(routeMaster.sort_order)) {
        toast.error("Please add valid sort order");
      } else {
        const editRouteMaster = {
          origin:
            origin && origin !== "undefined" ? origin : routeMaster.origin,
          destination:
            destination && destination !== "undefined"
              ? destination
              : routeMaster.destination,
          route_type: routeMaster.route_type,
          distance: routeMaster.distance,
          duration: routeMaster.duration,
          spot_route: routeMaster.spot_route,
          route_code: routeMaster.route_code,
          no_of_hops: routeMaster.no_of_hops,
          sort_order: routeMaster.sort_order,
          company_id: routeMaster.company_id,
          domain: routeMaster.domain,
          email: routeMaster.email,
          route_id: routeMaster.route_id ? routeMaster.route_id : "",
          route_status: routeMaster.route_status,
          last_updated_timestamp: new Date(),
        };
        const changedValues = findChangedValues(
          prevData,
          editRouteMaster,
          "changed_value",
        );
        const previous_data = findChangedValues(
          prevData,
          changedValues,
          "original_value",
        );

        if (
          editRouteMaster.route_type === "" ||
          locationName1.trim() === "" ||
          locationName2.trim() === "" ||
          locationName1 !== origin.location_name ||
          locationName2 !== destination.location_name ||
          isNaN(editRouteMaster.distance) ||
          editRouteMaster.distance <= 0 ||
          editRouteMaster.duration <= 0 ||
          isNaN(editRouteMaster.duration) ||
          editRouteMaster.spot_route === undefined
        ) {
          toast.error("Please Enter Valid Data");
          return false;
        } else {
          setshow(true);
          Axios.put(
            `${Urls.companyMaster}?edit=route&company_id=${company_id}`,
            editRouteMaster,
          )
            .then((res) => {
              sendMailToMasters(
                "Route Master",
                emailTemplate,
                superAdmins,
                {
                  action: "Route Edited",
                  lane: editRouteMaster,
                },
                setshow,
                userDetails?.user_name || userDetails?.email?.split("@")[0],
              );
              setshow(false);
              var activity = {
                route_id: prevData.route_id,
                route_code: prevData.route_code,
                route_name: `${prevData.origin.location_name} to ${prevData.destination.location_name}`,
                existing_data: previous_data,
                updated_data: changedValues,
              };
              MastersChangeLog(
                "Line Item Updated",
                "route_master",
                userDetails.email,
                userDetails.user_id,
                company_id,
                activity,
                "",
              );
              TrackMixPanel({
                ModuleName: "masters",
                ScreenName: "other master -route master",
                Definition: "user has clicked on route master save button",
                Data: `User Edited Origin: ${editRouteMaster?.origin?.location_name ? editRouteMaster.origin.location_name : "none"}, Destination :${editRouteMaster?.destination?.location_name ? editRouteMaster.destination.location_name : "none"}, Route Type :${editRouteMaster?.route_type ? editRouteMaster.route_type : "none"}, Distance :${editRouteMaster?.distance ? editRouteMaster.distance : "none"}, Duration : ${editRouteMaster?.duration ? editRouteMaster.duration : "none"}, Route code: ${editRouteMaster?.route_code ? editRouteMaster.route_code : "none"}, Spot Route: ${editRouteMaster?.spot_route ? editRouteMaster.spot_route : "none"}, No. of hops: ${editRouteMaster?.no_of_hops ? editRouteMaster.no_of_hops : "none"}, sort order: ${editRouteMaster?.sort_order ? editRouteMaster.sort_order : "none"}`,
              });

              var list = routeMasterList.map((list, idx) => {
                if (index === idx) {
                  list = editRouteMaster;
                }
                return list;
              });
              setRouteMasterList(list);
              document.getElementById("close_contactus1").click();
              toast.success("Details Edited Successfully");
            })
            .catch((e) => {
              console.log(e);
              setshow(false);
            });
        }
      }
    };

    return (
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-md-6 col-lg-4 mb-4">
            <label className="form-label fw-bold">Origin</label>
            <AutoComplete
              key="Origin_Key"

              module_key="indents"
              user_identifier={userDetails?.profile_company_id}

              value={
                locationName1
                  ? { label: locationName1, value: locationName1 }
                  : null
              }

              placeholder="Select Origin"

              onChange={(val) => setLocationName1(val)}   // string
              onSelect={(obj) => setOrigin(obj)}          // full object

              className="mt-1"

              customStyles={{
                control: (base, state) => ({
                  ...base,
                  height: "38px",
                  minHeight: "38px",
                  borderRadius: "4px",
                  border: state.isFocused
                    ? "1px solid #80bdff"
                    : "1px solid #ced4da",
                  boxShadow: "none",
                })
              }}
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Origin ID</label>
            <input
              value={origin?.location_code || ""}
              disabled
              // className="form-control"
              className={`form-control ${classes.input_field_control}`}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <label className="form-label fw-bold">Destination</label>
            <AutoComplete
              key="Destination_Key"

              module_key="indents"
              user_identifier={userDetails?.profile_company_id}

              value={
                locationName2
                  ? { label: locationName2, value: locationName2 }
                  : null
              }

              placeholder="Select Destination"

              onChange={(val) => setLocationName2(val)}   // string
              onSelect={(obj) => setDestination(obj)}     // full object

              className="mt-1"

              customStyles={{
                control: (base, state) => ({
                  ...base,
                  height: "38px",
                  minHeight: "38px",
                  borderRadius: "4px",
                  border: state.isFocused
                    ? "1px solid #80bdff"
                    : "1px solid #ced4da",
                  boxShadow: "none",
                })
              }}
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Destination ID</label>
            <input
              value={destination?.location_code || ""}
              disabled
              // className="form-control"
              className={`form-control ${classes.input_field_control}`}
            />
          </div>
          <div className="col-md-6 col-lg-4">
            <label className="form-label fw-bold">Route Type</label>
            <Select
              options={[{ value: "point_to_point", label: "Point-to-Point" }]}
              onChange={(e) => {
                routeMaster.route_type = e.value;
              }}
              defaultValue={routeMaster.route_type}
              placeholder={routeMaster.route_type || "Select.."}
              isSearchable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Distance</label>
            <input
              type="number"
              className={`form-control ${classes.input_field_control}`}
              onChange={(e) => {
                routeMaster.distance = Number(e.target.value);
              }}
              defaultValue={routeMaster.distance}
              placeholder="0"
            // style={{height: "52%"}}
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Duration</label>
            <input
              type="number"
              className={`form-control ${classes.input_field_control}`}
              onChange={(e) => {
                routeMaster.duration = Number(e.target.value);
              }}
              defaultValue={routeMaster.duration}
              placeholder="0"
            // style={{height: "52%"}}
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Route Code</label>
            <input
              type="text"
              className={`form-control ${classes.input_field_control}`}
              disabled
              onChange={(e) => {
                routeMaster.route_code = e.target.value;
              }}
              defaultValue={routeMaster.route_code}
              style={{ height: "52%" }}
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Spot Route</label>
            <Select
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={(e) => {
                routeMaster.spot_route = e.value;
              }}
              defaultValue={routeMaster.spot_route}
              placeholder={routeMaster.spot_route ? "Yes" : "No"}
              isSearchable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">No. of hops</label>
            <input
              type="number"
              className={`form-control ${classes.input_field_control}`}
              onChange={(e) => {
                routeMaster.no_of_hops = Number(e.target.value);
              }}
              defaultValue={routeMaster.no_of_hops}
            // style={{height: "52%"}}
            />
          </div>
          <div className="col-md-6 col-lg-2">
            <label className="form-label fw-bold">Sort Order</label>
            <input
              type="text"
              className={`form-control ${classes.input_field_control}`}
              onChange={(e) => {
                routeMaster.sort_order = e.target.value;
              }}
              defaultValue={routeMaster.sort_order}
            // style={{height: "52%"}}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 text-center">
            <button
              className="btn btn-success"
              onClick={() => handleEditSave(routeMaster, index)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  };
  // const handleSave = (routeMasterList) => {
  //     setshow(true)
  //     var route_master = routeMasterList.map((list) => {
  //         return {
  //             "origin": list.origin,
  //             "destination": list.destination,
  //             "route_type": list.route_type,
  //             "distance": list.distance ? list.distance : '',
  //             "duration": list.duration ? list.duration : '',
  //             "spot_route": list.spot_route ? list.spot_route : false,
  //             "route_code": list.route_code,
  //             "no_of_hops": list.no_of_hops ? list.no_of_hops : '',
  //             "sort_order": list.sort_order ? list.sort_order : '',
  //         }
  //     })
  //     console.log(route_master, 'route_master')
  // console.log(added_list, 'added_list')
  // saveMastersApi(company_id, 'route', added_list)
  // .then(res => {
  //     setshow(false)
  //     toast.success("Data submitted successfully")
  // })
  // .catch(err => {
  //     setshow(false)
  //     console.log(err)
  // })
  // }

  /**
   * Closes the modal and refreshes route master data.
   */
  const closeModal = async () => {
    setshow(true);
    getRouteData(buildDefaultPayload(0, 500), selectedOrg);
  };

  /**
   * Handles selection of all items for bulk deletion.
   * @param {Event} e - Event object for select all button
   */
  const selectAllHandler = (e) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      if (routeMasterList && routeMasterList.length > 0) {
        routeMasterList.map((item) => {
          if (!deletion_list.includes(item)) {
            list.push(item);
          }
        });
        setDeletion_list(list);
      }
    } else {
      setDeletion_list([]);
    }
  };

  /**
   * Handles checkbox selection for individual items.
   * @param {Event} e - Event object for item level checkbox
   * @param {Object} item - Selected route master item
   */
  const checkboxeshandler = (e, item) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      list.push(item);
      setDeletion_list(list);
    } else {
      var temp = deletion_list.filter((value) => {
        if (value !== item) {
          return value;
        }
      });
      setDeletion_list(temp);
    }
  };
  
  const handleFilterApply = (payload, showToast = true) => {
    setIsFilterLoading(true);
    setIsFilterActive(true);
    setFilterPayload(payload);

    if (payload?.pagination?.skip === 0) {
      setSkipactive(0);
    }

    getRouteData(payload, selectedOrg, showToast);
    setIsFilterLoading(false);
  };

  const handleFilterReset = () => {
    setIsFilterActive(false);
    setFilterPayload(null);
    setSkipactive(0);
    getRouteData(buildDefaultPayload(0, 500), selectedOrg);
    toast.info("Filters reset");
  };

  const ActiveFilterPills = () => {
    if (!isFilterActive || !filterPayload) return null;

    const hasFilters =
      filterPayload.filters && filterPayload.filters.length > 0;
    const hasSearch =
      filterPayload.search && filterPayload.search.trim() !== "";

    const currentSortKey = filterPayload.sort?.key;
    const isDefaultSort = currentSortKey === "route_code" || !currentSortKey;
    const currentSortLabel =
      DEFAULT_SORT_OPTIONS.find((o) => o.value === currentSortKey)?.label ||
      currentSortKey;
    const hasSort = !isDefaultSort;

    const currentLimit = filterPayload.pagination?.limit;
    const hasPagination = currentLimit && currentLimit !== 500;

    if (!hasFilters && !hasSearch && !hasSort && !hasPagination) return null;

    const removeFilter = (filterKey) => {
      const updatedFilters = filterPayload.filters.filter(
        (f) => f.key !== filterKey,
      );
      if (
        updatedFilters.length === 0 &&
        (!filterPayload.search || filterPayload.search.trim() === "") &&
        !hasSort &&
        !hasPagination
      ) {
        handleFilterReset();
      } else {
        const updated = {
          ...filterPayload,
          filters: updatedFilters,
          pagination: { ...filterPayload.pagination, skip: 0 },
        };
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const clearSearch = () => {
      const updated = {
        ...filterPayload,
        search: "",
        pagination: { ...filterPayload.pagination, skip: 0 },
      };
      if (!hasFilters && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const resetSort = () => {
      const updated = {
        ...filterPayload,
        sort: { key: "route_code", order: "asc" },
        pagination: { ...filterPayload.pagination, skip: 0 },
      };
      if (!hasFilters && !hasSearch && !hasPagination) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const resetPagination = () => {
      const updated = {
        ...filterPayload,
        pagination: { ...filterPayload.pagination, limit: 500, skip: 0 },
      };
      if (!hasFilters && !hasSearch && !hasSort) {
        handleFilterReset();
      } else {
        setFilterPayload(updated);
        handleFilterApply(updated);
      }
    };

    const formatValue = (value) =>
      Array.isArray(value) ? value.join(", ") : value;

    return (
      <div className={classes["active-filters-area"]}>
        <div className={classes["filter-header"]}>
          <i className="fa fa-filter mr-2 text-primary" />
          <span className={classes["filter-text"]}>Active Filters</span>
        </div>

        <div className={classes["filter-content"]}>
          {hasSearch && (
            <div
              className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}
            >
              <span className={classes["filter-pill-text"]}>
                <i
                  className={`fa fa-search mr-1 text-info ${classes["filter-pill-icon"]}`}
                />
                <strong className="mr-1">Search:</strong> {filterPayload.search}
              </span>
              <i
                className="fa fa-times ml-2 text-danger"
                onClick={clearSearch}
              />
            </div>
          )}

          {filterPayload.filters?.map((f, i) => (
            <div
              key={`${f.key}_${i}`}
              className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}
            >
              <span className={classes["filter-pill-text"]}>
                <i
                  className={`fa fa-check-circle mr-1 text-success ${classes["filter-pill-icon"]}`}
                />
                <strong className="mr-1">{f.label || f.key}:</strong>{" "}
                {formatValue(f.values)}
              </span>
              <i
                className="fa fa-times ml-2 text-danger"
                onClick={() => removeFilter(f.key)}
              />
            </div>
          ))}

          {hasSort && (
            <div
              className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}
            >
              <span className={classes["filter-pill-text"]}>
                <i
                  className={`fa fa-sort mr-1 text-warning ${classes["filter-pill-icon"]}`}
                />
                <strong className="mr-1">Sort:</strong> {currentSortLabel}
              </span>
              <i className="fa fa-times ml-2 text-danger" onClick={resetSort} />
            </div>
          )}

          {hasPagination && (
            <div
              className={`${classes["filter-pill"]} d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1`}
            >
              <span className={classes["filter-pill-text"]}>
                <i
                  className={`fa fa-list-ol mr-1 ${classes["filter-pill-icon"]}`}
                />
                <strong className="mr-1">Limit:</strong> {currentLimit}
              </span>
              <i
                className="fa fa-times ml-2 text-danger"
                onClick={resetPagination}
              />
            </div>
          )}
        </div>

        <button
          className={classes["btn-clear-all"]}
          onClick={handleFilterReset}
        >
          Clear All
        </button>
      </div>
    );
  };

  /**
   * Handles pagination change.
   * @param {number} e - New page number
   */
  const getOnChange = (e) => {
    setSkipactive(e);
    if (isFilterActive && filterPayload) {
      const currentLimit = filterPayload?.pagination?.limit || 500;
      const dynamicSkip = (e - 1) * currentLimit;
      const updated = {
        ...filterPayload,
        pagination: {
          ...filterPayload.pagination,
          skip: dynamicSkip,
          limit: currentLimit,
        },
      };
      setFilterPayload(updated);
      getRouteData(updated, selectedOrg);
    } else {
      const calculatedSkip = (e - 1) * 500;
      getRouteData(buildDefaultPayload(calculatedSkip, 500), selectedOrg);
    }
  };

  return (
    <>
      {filtersshown && (
        <div className="mt-4 mb-4">
          <MultiSelectFilterUI
            module="RouteMaster"
            action="filterable_fields"
            filterBaseUrl={Urls.planning_master_filters}
            uniqueValuesMasterType="route"
            defaultFields={[
              { key: "route_code", label: "Route Code", type: "text" },
              { key: "route_type", label: "Route Type", type: "enum" },
              { key: "distance", label: "Distance", type: "text" },
              { key: "duration", label: "Duration", type: "text" },
              { key: "spot_route", label: "Spot Route", type: "enum" },
            ]}
            defaultSortOptions={DEFAULT_SORT_OPTIONS}
            onFilterApply={handleFilterApply}
            onReset={handleFilterReset}
            initialPayload={filterPayload}
            isLoading={isFilterLoading || show}
            onClose={() => setfiltershown(false)}
            showSearch={false}
          />
        </div>
      )}

      <div className={`${classes["other-container"]}`}>
        <MasterDropdown
          activeTab="route-master"
          selectedOrg={selectedOrg}
          setSelectedOrg={setSelectedOrg}
          orgList={orgList}
          isOrgLevel={isOrgLevel}
          setSkipactive={setSkipactive}
          canedit={canedit}
          canUpdate={canUpdate}
          checkActionPermission={checkActionPermission}
        />
        <AddNewItem
          routeMasterList={routeMasterList}
          setRouteMasterList={setRouteMasterList}
        />

        <div className="row col-md-12 px-0 mx-0">
          <div className="col-12 px-0">
            <ActiveFilterPills />
          </div>
          <div className={`position-absolute w-100 ${show ? "h-50" : ""}`}>
            <Loader show={show} />
          </div>

          <div className={`${classes["table-alignment"]}`}>
            <table
              className={`table table-borderless ${classes["table-width"]}`}
              id="freight_master_table"
            >
              <thead className={`${classes["table-head"]}`}>
                <tr style={{ fontSize: "12px" }}>
                  <th
                    className={`${classes["sticky-th"]} pl-2`}
                    style={{ width: "2%" }}
                  >
                    <input
                      type="checkbox"
                      checked={
                        routeMasterList &&
                        routeMasterList.length > 0 &&
                        deletion_list.length === routeMasterList.length
                      }
                      onChange={selectAllHandler}
                      style={{ width: "15px", height: "15px" }}
                    />
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "5%" }}
                  >
                    Sr No.
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "18%" }}
                  >
                    Origin
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "8%" }}
                  >
                    Origin Code
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "18%" }}
                  >
                    Destination
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "8%" }}
                  >
                    Destination Code
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "10%" }}
                  >
                    Route Type
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "4%" }}
                  >
                    Distance
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "4%" }}
                  >
                    Duration
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "8%" }}
                  >
                    Route Code
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "4%" }}
                  >
                    Spot Route
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "4%" }}
                  >
                    No of hops
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "3%" }}
                  >
                    Sort Order
                  </th>
                  <th
                    scope="col"
                    className={`${classes["sticky-th"]}`}
                    style={{ textAlign: "center", width: "4%", zIndex: "1" }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {routeMasterList && routeMasterList.length > 0
                  ? routeMasterList.map((data, index) => {
                    return (
                      <tr key={index} style={{ fontSize: "12px" }}>
                        <td
                          className={` pl-2 ${classes["borderforTd"]}`}
                          style={{ width: "2%" }}
                        >
                          <input
                            type="checkbox"
                            style={{ width: "15px", height: "15px" }}
                            onChange={(e) => checkboxeshandler(e, data)}
                            checked={deletion_list.includes(data)}
                          />
                        </td>
                        <td
                          style={{ textAlign: "center", width: "5%" }}
                          className={classes["borderforTd"]}
                        >
                          {index + 1}.
                        </td>
                        <td
                          style={{ textAlign: "center", width: "18%" }}
                          className={classes["borderforTd"]}
                          title={
                            data.origin && data.origin.location_name
                              ? data.origin.location_name
                              : false
                          }
                        >
                          {data.origin && data.origin.location_name
                            ? data.origin.location_name
                            : ""}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "8%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.origin && data.origin.location_code
                            ? data.origin.location_code
                            : "-"}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "18%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.destination && data.destination.location_name
                            ? data.destination.location_name
                            : ""}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "8%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.destination && data.destination.location_code
                            ? data.destination.location_code
                            : "-"}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "10%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.route_type}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "4%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.distance}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "4%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.duration}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "8%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.route_code}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "4%" }}
                          className={classes["borderforTd"]}
                        >
                          {data?.spot_route === true ? "Yes" : "No"}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "4%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.no_of_hops}
                        </td>
                        <td
                          style={{ textAlign: "center", width: "3%" }}
                          className={classes["borderforTd"]}
                        >
                          {data.sort_order}
                        </td>
                        <td style={{ width: "4%" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Modal
                              buttonLabel={
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                />
                              }
                              buttonClass={`btn btn-link text-dark`}
                              style={{}}
                              disabled={canedit || !canUpdate}
                              content={
                                <EditRouteMaster
                                  superAdmins={superAdmins}
                                  emailTemplate={emailTemplate}
                                  routeMaster={data}
                                  index={index}
                                  userDetails={userDetails}
                                />
                              }
                              title={`Edit Route Master`}
                              id="routemaster"
                              screenName="Route Master"
                              moduleName="Route Master"
                              onClose={closeModal}
                            />
                            <button
                              className={`btn btn-link text-dark`}
                              onClick={(e) => deleteHandler(e, data)}
                              style={{}}
                              disabled={canedit || !canUpdate}
                            >
                              <i
                                className={`${classes["edit-option"]} fa fa-trash`}
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                  : null}
              </tbody>
            </table>
          </div>
          <div style={{ display: "none" }}>
            <table id="route_master_table">
              <thead>
                <tr>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Sr No.
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Origin Code
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Origin*
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Origin District
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Origin State*
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Origin Pincode
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Destination Code
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Destination*
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Destination District
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Destination State*
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Destination Pincode
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Route Type*
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Distance
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Duration
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Spot Route
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Route Code*
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    No of hops
                  </th>
                  <th
                    className={classes["col1"]}
                    style={{ textAlign: "center" }}
                  >
                    Sort Order
                  </th>
                </tr>
              </thead>
              <tbody>
                {downloadData && downloadData.length > 0
                  ? downloadData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.origin.location_code}</td>
                      <td>{item.origin.location_name.split(",")[0]}</td>
                      <td>{item.origin.location_name.split(",")[1]}</td>
                      <td>{item.origin.location_name.split(",")[2]}</td>
                      <td>
                        {item.origin.pincode ? item.origin.pincode : ""}
                      </td>
                      <td>{item.destination.location_code}</td>
                      <td>{item.destination.location_name.split(",")[0]}</td>
                      <td>{item.destination.location_name.split(",")[1]}</td>
                      <td>{item.destination.location_name.split(",")[2]}</td>
                      <td>
                        {item.destination.pincode
                          ? item.destination.pincode
                          : ""}
                      </td>
                      <td>{item.route_type}</td>
                      <td>{item.distance}</td>
                      <td>{item.duration}</td>
                      <td>{item.spot_route ? "Yes" : "No"}</td>
                      <td>{item.route_code}</td>
                      <td>{item.no_of_hops ? item.no_of_hops : ""}</td>
                      <td>{item.sort_order ? item.sort_order : ""}</td>
                    </tr>
                  ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>
        <div className="text-center mt-3">
          <Pagination
            activePage={skipactive === 0 ? 1 : skipactive}
            itemsCountPerPage={filterPayload?.pagination?.limit || 500}
            totalItemsCount={totalcount}
            onChange={(e) => getOnChange(e)}
            itemClass="page-item"
            linkClass="page-link"
          // hideDisabled
          />
        </div>
      </div>
    </>
  );
};

export default RouteMaster;
